import { TlfArsListingReadDto, TlfArsTableReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { createPatch, Operation, Patch } from "rfc6902";
import { pickVariantUpdateable } from "./pickVariantUpdateable";

export interface VariantPatchResult {
  /** The remove and replace operations that turn the master into the current TLF. */
  patch: Patch;
  /** Operations reported as invalid; reporting is temporarily disabled. */
  invalidOps: Operation[];
  /** The reverse operations that turn the current TLF back into the master. */
  reverseOps: Patch;
}

/**
 * Build the rfc6902 patch that transforms the master into the currently edited TLF.
 * Only the variant updateable properties are compared, so unrelated edits never leak
 * into a patch. Operations other than remove and replace are not currently flagged.
 *
 * @param master - The master snapshot captured when variant creation started
 * @param current - The TLF item as currently edited
 * @returns The permitted operations; invalid-operation reporting is temporarily disabled
 */
export const buildVariantPatch = <T extends TlfArsListingReadDto | TlfArsTableReadDto>(
  master: T,
  current: T,
): VariantPatchResult => {
  const allOps = createPatch(pickVariantUpdateable(master), pickVariantUpdateable(current));
  const reverseOps = createPatch(pickVariantUpdateable(current), pickVariantUpdateable(master));

  return {
    // TODO: Restore or remove these
    // Unsure if there will be invalid patch types at this point,
    // but I would like to have the functionality there just in case
    // patch: allOps.filter((op) => op.op === "remove" || op.op === "replace"),
    // invalidOps: allOps.filter((op) => op.op !== "remove" && op.op !== "replace"),
    patch: allOps.filter(() => true),
    invalidOps: allOps.filter(() => false),
    reverseOps,
  };
};
